import { Location } from '@reach/router';
import React from 'react';

const withLocation = (ComponentToWrap) =>
  function LocationWrapper(props) {
    return (
      <Location>
        {({ location, navigate }) => {
          return (
            <ComponentToWrap
              {...props}
              location={location}
              navigate={navigate}
              params={location?.search ? new URLSearchParams(location?.search) : null}
            />
          );
        }}
      </Location>
    );
  };

export default withLocation;
